import api from '../api'

export default {
    namespaced: true,
    state: {
        accountPayeeCheckList: {
            beanList: [],
            total: 0
        },
        accountPayeeCheckInfo: {
            alipayInfos: [],// 支付宝
            bankInfos: [],// 银行卡
            type: null
        },
    },
    mutations: {
        setStateAccountPayeeCheckList(state, info) {
            state.accountPayeeCheckList = info
        },
        setStateAccountPayeeCheckInfo(state, info) {
            state.accountPayeeCheckInfo = info
        }
    },
    actions: {
        getAccountPayeeCheckList({commit}, params) {
            return api.post(`/accountPayeeChecks/list`, '提豆信息审核 - 列表', params).then(res => {
                commit('setStateAccountPayeeCheckList', res.data)
            })
        },
        getAccountPayeeCheckInfo({commit}, accountPayeeCheck) {
            return api.post(`/accountPayeeChecks/info`, '提豆信息审核 - 信息', {accountPayeeCheck}).then(res => {
                commit('setStateAccountPayeeCheckInfo', res.data)
            })
        },
        agreeAccountPayeeCheck(store, accountPayeeCheck) {
            return api.post(`/accountPayeeChecks/agree`, '提豆信息审核 - 同意', {accountPayeeCheck})
        },
        rejectAccountPayeeCheck(store, accountPayeeCheck) {
            return api.post(`/accountPayeeChecks/reject`, '提豆信息审核 - 拒绝', {accountPayeeCheck})
        }
    }
}